import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { LayersIcon, FileSpreadsheetIcon, ActivityIcon, UsersIcon } from 'lucide-react';
const problems = [{
  icon: LayersIcon,
  title: 'Fragmented Silos',
  description: 'Ad data scattered across Google Ads, Meta, TikTok, and LinkedIn with no unified view.',
  color: 'text-accent-indigo',
  bg: 'bg-accent-indigo/10',
  border: 'border-accent-indigo/20'
}, {
  icon: FileSpreadsheetIcon,
  title: 'Manual Report Drudgery',
  description: 'Hours wasted copying and pasting data into spreadsheets every single week.',
  color: 'text-accent-amber',
  bg: 'bg-accent-amber/10',
  border: 'border-accent-amber/20'
}, {
  icon: ActivityIcon,
  title: 'Invisible Anomalies',
  description: "Budget bleeds and performance drops go unnoticed until it's too late.",
  color: 'text-accent-red',
  bg: 'bg-accent-red/10',
  border: 'border-accent-red/20'
}, {
  icon: UsersIcon,
  title: 'Client Distrust',
  description: 'Without real-time transparency, client confidence erodes over time.',
  color: 'text-accent-teal',
  bg: 'bg-accent-teal/10',
  border: 'border-accent-teal/20'
}];
export function ProblemsSection() {
  return <section id="platform" className="py-24 px-6 bg-navy-900 border-t border-navy-700/50" data-id="element-264">
      <div className="max-w-7xl mx-auto" data-id="element-265">
        <div className="text-center mb-16" data-id="element-266">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-267">
            The Reporting Nightmare Agencies Know Too Well
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-268">
            Operating without a central source of truth costs agencies time,
            money, and client trust.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-269">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-navy-800 border border-navy-700 rounded-xl p-6 hover:border-navy-600 transition-colors group" data-id="element-270">
              <div className={`w-12 h-12 rounded-lg ${problem.bg} ${problem.border} border flex items-center justify-center mb-6`} data-id="element-271">
                <problem.icon className={`w-6 h-6 ${problem.color}`} data-id="element-272" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-3 group-hover:text-accent-teal transition-colors" data-id="element-273">
                {problem.title}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-274">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}